import global$1 from './global.js';
import isObject$1 from './is-object.js';

var global = global$1;
var isObject = isObject$1;
var String = global.String;
var TypeError = global.TypeError; // `Assert: Type(argument) is Object`

var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

export { anObject as default };
